import { PackageOpen } from "lucide-react";

export default function EmptyState({ title = "No records found", message = "Try adjusting your search or filters.", testId = "empty-state" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid={testId}>
      <div className="h-14 w-14 rounded-sm bg-slate-100 flex items-center justify-center mb-4">
        <PackageOpen className="h-7 w-7 text-slate-400" />
      </div>
      <div className="text-base font-semibold text-slate-800">{title}</div>
      <div className="text-sm text-slate-500 mt-1 max-w-sm">{message}</div>
    </div>
  );
}
